<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/who/` : "/api/who/"
const { data } = await useFetch(apiUrl, { key: "home-who" })

const resolveImageUrl = (url) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/media/")) return url
  return url
}

const sectionData = computed(() => data.value?.section || null)
const cards = computed(() => (data.value?.cards?.length ? data.value.cards : []))

const verticalCards = computed(() => cards.value.filter((c) => c.layout === "vertical"))
const horizontalCards = computed(() => cards.value.filter((c) => c.layout === "horizontal"))

</script>

<template>
  <section v-if="sectionData" class="section-who">
      <div class="section__title">
        <div class="title__text__wrapper who-title-width"
             style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);">
          <div class="section__tag">
            <p class="text-regular-16 color-text-dark">{{ sectionData.tag_label }}</p>
            <div class="icon-14">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none">
                <path d="M11.813 3.9375H2.18799C1.94636 3.9375 1.75049 4.13338 1.75049 4.375V11.375C1.75049 11.6166 1.94636 11.8125 2.18799 11.8125H11.813C12.0546 11.8125 12.2505 11.6166 12.2505 11.375V4.375C12.2505 4.13338 12.0546 3.9375 11.813 3.9375Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M9.1875 3.9375V3.0625C9.1875 2.83044 9.09531 2.60788 8.93122 2.44378C8.76712 2.27969 8.54456 2.1875 8.3125 2.1875H5.6875C5.45544 2.1875 5.23288 2.27969 5.06878 2.44378C4.90469 2.60788 4.8125 2.83044 4.8125 3.0625V3.9375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M12.2503 6.90753C10.6547 7.83069 8.84331 8.3154 6.99989 8.3125C5.15678 8.3154 3.34568 7.83085 1.75024 6.90799" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M6.34375 6.5625H7.65625" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>
          <h3 class="h3-40">{{ sectionData.title }}</h3>
        </div>
        <div class="title__description__wrapper width-588"
             style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);">
          <div class="text-regular-18" v-html="sectionData.description"></div>
        </div>
      </div>
      <div class="who__container">
        <div v-if="verticalCards[0]" class="card-vertical" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
          <div class="card-vertical__text-wrapper">
            <h4>{{ verticalCards[0].title }}</h4>
            <div class="text-regular-16" v-html="verticalCards[0].description"></div>
          </div>
          <div class="card-vertical__bottom">
            <div class="icon-80">
              <img v-if="verticalCards[0].icon_url" :src="resolveImageUrl(verticalCards[0].icon_url)" alt="" class="image-cover">
            </div>
          </div>
        </div>
        <div class="who__middle-cards">
          <div v-for="card in horizontalCards" :key="card.id" class="card-horizontal" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
            <div class="card-horizontal__deco">
              <div class="icon-80">
                <img v-if="card.icon_url" :src="resolveImageUrl(card.icon_url)" alt="" class="image-cover">
              </div>
            </div>
            <div class="card-horizontal__text-wrapper">
              <h4>{{ card.title }}</h4>
              <div class="text-regular-16" v-html="card.description"></div>
            </div>
          </div>
        </div>
        <div v-if="verticalCards[1]" class="card-vertical" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
          <div class="card-vertical__text-wrapper">
            <h4>{{ verticalCards[1].title }}</h4>
            <div class="text-regular-16" v-html="verticalCards[1].description"></div>
          </div>
          <div class="card-vertical__bottom">
            <div class="icon-80">
              <img v-if="verticalCards[1].icon_url" :src="resolveImageUrl(verticalCards[1].icon_url)" alt="" class="image-cover">
            </div>
          </div>
        </div>
      </div>
    <div id="about" class="scroll-anchor about-section"></div>
  </section>
</template>

<style lang="scss" scoped>
@use '/assets/scss/sections/_who.scss';
</style>
